import produce from 'immer'

import { types } from './actions'

export const initialState = {
    tag: null,
    xprops: null,
    error: null,
}

const reducer = (state = initialState, { type, payload }) => produce(state, (draftState) => {
    switch (type) {
        case types.ZOID_INIT:
            return initialState

        case types.ZOID_INIT_SUCCESS:
            draftState.xprops = payload.xprops
            draftState.tag = payload.tag
            break

        case types.ZOID_ON_PROPS:
            draftState.xprops = payload.xprops
            break

        default:
        // do nothing
    }

    return undefined
})

export default reducer
